export interface FieldConfig {
  key: string;
  label: string;
  hideable?: boolean;
}

export const naturalPersonFields: FieldConfig[] = [
  { key: 'title', label: 'Title', hideable: false },
  { key: 'name', label: 'Name', hideable: false },
  { key: 'surname', label: 'Surname', hideable: false },
  { key: 'idNumber', label: 'ID Number', hideable: true },
  { key: 'email', label: 'Email Address', hideable: true },
  { key: 'mobileNumber', label: 'Mobile Number', hideable: true },
  { key: 'taxNumber', label: 'Tax Number', hideable: true },
  { key: 'ficaStatus', label: 'FICA Status', hideable: true },
  { key: 'physicalAddress', label: 'Physical Address', hideable: true },
  { key: 'workTelephone', label: 'Work Telephone Number', hideable: true },
  { key: 'homeTelephone', label: 'Home Telephone Number', hideable: true },
  { key: 'nationalityCountry', label: 'Nationality Country', hideable: true },
  { key: 'dateOfBirth', label: 'Date of Birth', hideable: true },
  { key: 'residenceCountry', label: 'Residence Country', hideable: true },
  { key: 'maritalStatus', label: 'Marital Status', hideable: true },
  { key: 'postalAddress', label: 'Postal Address', hideable: true },
  { key: 'country', label: 'Country', hideable: true },
  { key: 'employmentStatus', label: 'Employment Status', hideable: true },
  { key: 'industry', label: 'Industry / Sector', hideable: true }
];

export const legalEntityFields: FieldConfig[] = [
  { key: 'tradingName', label: 'Trading Name', hideable: false },
  { key: 'registrationNumber', label: 'Registration number', hideable: false },
  { key: 'contactName', label: 'Contact name', hideable: false },
  { key: 'email', label: 'Contact email address', hideable: true },
  { key: 'mobileNumber', label: 'Contact mobile number', hideable: true },
  { key: 'taxNumber', label: 'Tax number', hideable: true },
  { key: 'physicalAddress', label: 'Physical address', hideable: true },
  { key: 'ficaStatus', label: 'FICA status', hideable: true },
  { key: 'dateOfRegistration', label: 'Date of registration', hideable: true },
  {
    key: 'countryOfIncorporation',
    label: 'Country of incorporation',
    hideable: true
  },
  { key: 'countryOfOperation', label: 'Country of operation', hideable: true },
  {
    key: 'workTelephoneNumber',
    label: 'Work telephone number',
    hideable: true
  },
  { key: 'postalAddress', label: 'Postal address', hideable: true },
  { key: 'sector', label: 'Industry / sector', hideable: true }
];
